import { render, staticRenderFns } from "./CarManage.vue?vue&type=template&id=271d13af&"
import script from "./CarManage.vue?vue&type=script&lang=js&"
export * from "./CarManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports